import { render, staticRenderFns } from "./DeliveryInfo.vue?vue&type=template&id=fa8a2cce&scoped=true&"
import script from "./DeliveryInfo.vue?vue&type=script&lang=js&"
export * from "./DeliveryInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryInfo.vue?vue&type=style&index=0&id=fa8a2cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa8a2cce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa8a2cce')) {
      api.createRecord('fa8a2cce', component.options)
    } else {
      api.reload('fa8a2cce', component.options)
    }
    module.hot.accept("./DeliveryInfo.vue?vue&type=template&id=fa8a2cce&scoped=true&", function () {
      api.rerender('fa8a2cce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/publishGoods/components/DeliveryInfo.vue"
export default component.exports